import {
  FormControlLabel,
  Switch as MUISwitch,
  SwitchProps as MUISwitchProps,
} from "@mui/material";
export type SwitchProps = Omit<MUISwitchProps, "ref"> & {
  className?: string;
  label: string;
};
export default function Switch({ label, className, id, disabled, onChange, checked }: SwitchProps) {
  return (
    <FormControlLabel
      control={<MUISwitch onChange={onChange} checked={checked} />}
      id={id ?? label}
      disableTypography={true}
      disabled={disabled}
      label={label}
      labelPlacement="start"
      className={
        "m-0 py-3 px-4 text-xl w-full bg-ldir-gray-600 border-t border-ldir-blue-pale flex justify-between formLabel " +
        className
      }
    />
  );
}
